import { formatDate } from "@angular/common";
import { Pipe, PipeTransform, Inject, LOCALE_ID } from "@angular/core";
//import moment from "moment";
// import {invalidPipeArgumentError} from "./invalid_pipe_argument_error";

@Pipe({  
	name: "filter"  
})  

export class FilterPipe implements PipeTransform {  
	transform(items: any[], searchTerm: string, labelKey?: string) {  
		if (!items || !searchTerm) {  
			return items;  
		}  
  
		return items.filter(  
			item =>  
				item[labelKey || "label"]  
					.toLowerCase()  
					.includes(searchTerm.toLowerCase()) === true  
		);  
	}  
} 


// clang-format on
@Pipe({name: "supportDate", pure: true})
export class supportDatePipe implements PipeTransform {
	constructor(@Inject(LOCALE_ID) private locale: string) {}

	/**
   * @param value The date expression: a `Date` object,  a number
   * (milliseconds since UTC epoch), or an ISO string (https://www.w3.org/TR/NOTE-datetime).
   * @param format The date/time components to include, using predefined options or a
   * custom format string.
   * @param timezone A timezone offset (such as `'+0430'`), or a standard
   * UTC/GMT or continental US timezone abbreviation.
   * When not supplied, uses the end-user's local system timezone.
   * @param locale A locale code for the locale format rules to use.
   * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
   * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
   * @returns A date string in the desired format.
   */
	transform(value: Date|string|number, format?: string, timezone?: string, locale?: string): string
      |null;
	transform(value: null|undefined, format?: string, timezone?: string, locale?: string): null;
	transform(
      value: Date|string|number|null|undefined, format?: string, timezone?: string,
      locale?: string): string|null;
	transform(
		value: Date|string|number|null|undefined|any, format = "mediumDate", place?: string, timezone?: string,
		locale?: string): string|null {

		if (value == null || value === "" || value !== value) return null;

		try {
			value = value.toDate();

			if (place == "supportList") {
				const today = Date.now();
				const convertDate =value;
				//today.diff(convertDate, "days") >= 1? format = "MMM,d" : format = "shortTime" // 1
			}

			place == "chatField"? format = "medium": null;

			return formatDate(value, format, locale || this.locale, timezone);
		} catch (error:any) {
			console.error(error.message);
		}

		return null;
	}
}
